// extracted by mini-css-extract-plugin
export default {"rightArrow":"CarousalRightNav_rightArrow__DLlNZ"};